export const addInterestToPrice = (price: string, interest: string) => {
    let total = parseFloat(price) + parseFloat(interest);
    return total.toFixed(2);
}